const volcanes = {
  payingByMessage: 'Ödeme yaparak ',
  safePaymentPage: 'Güvenli ödeme sayfası',
  finishYourPaymentMessage: 'Satın almanızı tamamlayın, ödemenizi burada yapın :)',
  inputCustomerName: 'Ad Soyad',
  inputCustomerEmail: 'E-posta',
  inputCustomerPhoneNumber: 'Telefon',
  inputCustumerPhoneNumberOptional: '(isteğe bağlı)',
  emptyCardSecurityCode: 'Kartın güvenlik kodunu tamamlayın',
  invalidSecurityCode: 'Geçersiz güvenlik kodu',
  invalidCvv: 'Geçersiz CVV',
  fieldCardSecurityCode: 'Güvenlik kodu (CVV)',
  fieldCardHolderName: 'Tam ad (kartta göründüğü gibi)',
  fieldCardExpiryDate: 'Son kullanma tarihi',
  placeholderCardExpiryDate: 'AA/YYYY',
  fieldCardNumber: 'Kart numarası',
  fieldOneClickCardNumber: '{brand} son {lastFour}',
  transactionFeeTooltip: 'İşlem Maliyetleri',
  total: 'Toplam',
  amount: 'Ürün',
  termsLabel: 'Ödeme yaparak ',
  termsReferenceLink: 'hizmet şartlarını',
  termsEbanxLabel: ' kabul etmiş olursunuz. EBANX.',
  paymentPageTitle: 'Ödeme Sayfası',
  selectPaymentMethod: 'Ödeme yöntemi seçin',
  fatalErrorTitle: 'Hay aksi!',
  fatalErrorMessage: 'Maalesef ödeme bilgilerinizi bulamadık.',
  fatalErrorFooter: 'Güvenli ödeme altyapısı',
  panamaUsdDisclaimer: 'Ödemeler EBANX aracılığıyla işlenmektedir. Bölgesel yönlendirme nedeniyle, banka ekstrenizde USD doları ile 1:1 sabit kur uygulayan Panama (PAB) para birimi belirtilebilir. Nihai ücret, gösterilen USD doları fiyatını yansıtmalıdır.',
  merchantPaymentCode: 'Sipariş #',
};

module.exports = volcanes;
